/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import z from 'zod';
const CAPEX_SPEND_RELATIVE_TOLERANCE = 1e-5;
const CAPEX_SPEND_ABSOLUTE_TOLERANCE = 1e-8;
export const isCapexSpendScheduleTotalValid = (total) => Math.abs(total - 1) <=
    Math.max(CAPEX_SPEND_RELATIVE_TOLERANCE * Math.max(Math.abs(total), 1), CAPEX_SPEND_ABSOLUTE_TOLERANCE);
export const capexSpendScheduleSchema = z
    .object({
    milestone: z.string(),
    months_until_cod: z.number().int().min(0),
    percent_spend: z.number().min(0).max(1),
})
    .strict();
export const capexSpendScheduleListSchema = z
    .array(capexSpendScheduleSchema)
    .refine((schedule) => schedule.length === 0 ||
    isCapexSpendScheduleTotalValid(schedule.reduce((total, milestone) => total + milestone.percent_spend, 0)), 'Capex schedule must sum to 100%.');
//# sourceMappingURL=capex-spend-schedule.js.map